export const SCREEN_WIDTH_LG = 1439;
export const SCREEN_WIDTH_MD = 1200;
export const SCREEN_WIDTH_TABLET = 840;
export const SCREEN_WIDTH_PHONE = 560;
